<template>
  <div style="width:100%;height: 100%;">
    <div @click="click" class="word">
      docx
    </div>
    <officeScan ref="officeScan"></officeScan>
  </div>
</template>
<script>
import axios from "axios";
import officeScan from "./officeScan.vue";
export default {
  props: ["url"],
  components: { officeScan },
  data() {
    return {
      openIfram: false
    };
  },
  methods: {
    click() {
      let path = this.axios.platConfig.fileUri + this.url;
      this.$refs.officeScan.open(path, true);
      return;
      this.openIfram = true;
    }
  }
};
</script>
<style scrope>
.word {
  width: 100%;
  height: 100%;
  background: #0d72de;
  color: #fff;
  text-align: center;
  font-size: 14px;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/Docx.vue